/**
 *  @class
 *  @function CollectionListBanner
 *
 *  Copies the promo code to the clipboard and confirms it in the button label,
 *  the way the ESN campaign teaser does. The label swaps back after a moment so
 *  a second visitor on the same page still sees the call to action.
 */
if (!customElements.get('collection-list-banner')) {
  class CollectionListBanner extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-clb-copy]');

      if (!this.button) return;

      this.label = this.button.querySelector('span') || this.button;
      this.defaultText = this.button.dataset.text || this.label.textContent;
      this.copiedText = this.button.dataset.copiedText || this.defaultText;
      this.resetTimer = null;

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onClick);
      }
      clearTimeout(this.resetTimer);
    }

    onClick(event) {
      event.preventDefault();

      const code = this.button.dataset.code;

      if (!code) return;

      this.copy(code).then(() => {
        this.label.textContent = this.copiedText;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.label.textContent = this.defaultText;
        }, 2500);
      });
    }

    /* navigator.clipboard needs a secure context, which the theme editor
       preview does not always provide — hence the execCommand fallback. */
    copy(code) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(code).catch(() => this.copyFallback(code));
      }
      return this.copyFallback(code);
    }

    copyFallback(code) {
      const field = document.createElement('textarea');

      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'absolute';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy');
      } catch (e) {
        // Nothing to do — the code stays visible in the button either way
      }

      document.body.removeChild(field);
      return Promise.resolve();
    }
  }
  customElements.define('collection-list-banner', CollectionListBanner);
}
